import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {connect} from 'react-redux'
import {actionCreators, selectors} from '../store/actions/location'
import {noop, getComponentDisplayName} from '../utils'

/**
 * Higher order component for connecting to Redux location state. Now a convenience thing
 * more than anything
 * @param {Object} options - Initial config options.
 * @param {String} options.exposeState - Name of the props object that contains state attributes.
 * @param {String} options.exposeActions - Name of the props object that contains actions which modify state.
 * @returns {Function} The configured higher order component, which in turn will return a component class.
 */
export default ({exposeState = 'locationState', exposeActions = 'locationActions'} = {}) => (Wrapped) => {
  class ConnectLocation extends Component {
    static propTypes = {
      locationState: PropTypes.object,
      locationActions: PropTypes.object,
      children: PropTypes.node,
    }
    
    static defaultProps = {
      locationActions: {
        requestPostcodeInput: noop,
      },
    }
    
    render() {
      return <Wrapped {...{...this.props}} />
    }
  }
  
  ConnectLocation.displayName = `ConnectLocation(${getComponentDisplayName(Wrapped)})`
  
  const mapStateToProps = state => ({
    [exposeState]: selectors.getLocation(state),
  })
  
  const mapDispatchToProps = dispatch => ({
    [exposeActions]: Object.keys(actionCreators).reduce((actions, key) => {
      actions[key] = (...args) => dispatch(actionCreators[key](...args))
      return actions
    }, {}),
  })
  
  return connect(mapStateToProps, mapDispatchToProps)(ConnectLocation)
}



// WEBPACK FOOTER //
// ./src/higher-order-components/connect-location.jsx